/**
 * Modal — built on native <dialog>, not a hand-rolled overlay. Gets focus
 * trapping, Escape-to-close, and ::backdrop styling for free from the
 * browser. Appends itself to <body> and removes itself on close.
 */
export function Modal({ title, content, onClose }) {
  const dialog = document.createElement("dialog");
  dialog.className = "modal";

  const header = document.createElement("div");
  header.className = "modal-header";

  const heading = document.createElement("h3");
  heading.textContent = title;

  const closeBtn = document.createElement("button");
  closeBtn.className = "modal-close";
  closeBtn.setAttribute("aria-label", "Close");
  closeBtn.textContent = "×";
  closeBtn.addEventListener("click", () => dialog.close());

  header.append(heading, closeBtn);

  const body = document.createElement("div");
  body.className = "modal-body";
  body.append(content);

  dialog.append(header, body);

  dialog.addEventListener("close", () => {
    dialog.remove();
    onClose?.();
  });
  // Click on the backdrop (the dialog element's own padding box, outside
  // its rendered content box) closes it — native <dialog> has no built-in
  // "click outside to close".
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });

  document.body.append(dialog);
  dialog.showModal();
  return dialog;
}
